<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('addNewRelance.relancesGroupees') }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-cancel btn-modal-annuler"
                    @click="isFromClient ? $router.go(-1) : $router.push({
                      name: 'l.bodac.relance-listeDesRetards',
                      params: { getLastPayLoad: constantes.GET_LAST_PAY_LOAD },
                    })">
              {{ $t('addNewRelance.actions.cancel')}}
            </button>
            <button class="button is-addOrEdit" @click="isMultiRelance
              ? saveAllRelances() : saveRelance(currentRelance.id)">
              {{ isMultiRelance ? $t('addNewRelance.actions.saveMasse')
                : $t('general.button.sauvegarder') }}
            </button>
            <button class="button" v-if="currentRelance && !isMultiRelance"
                    @click="showAddAttachmentModal()">
              <b-icon
                icon="paperclip"
                type="is-default">
              </b-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <br>
    <error-msg-component
      v-if="error"
      :messages="messages"
      :messagesChampsVide="messagesChampsVide"
      :champsVide="champsVide"
      :error="error"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      @close="error = $event"/>
    <div class="columns" v-if="currentRelance">
      <div class="column is-9">
        <div class="card">
          <div class="card-content">
            <app-header-relance
              :date.sync="currentRelance.dateRelance"
              :numberRelance.sync="currentRelance.numRelance"
              @reinitialiserTexte="updateTexteRelance"/>
            <qd-text-editor v-model="currentRelance.texte" :height="500" />
          </div>
        </div>
        <div class="card mgt-20px">
          <header class="header-card">
            <p>{{ $t('relance.commentaire')}}</p>
          </header>
          <div class="card-content">
            <b-field
              :label="$t('addNewRelance.commentaire')">
              <b-input v-model="currentRelance.commentaire" type="textarea" :rows="4">
              </b-input>
            </b-field>
          </div>
        </div>
        <div class="card mgt-20px" v-if="currentRelance && !isMultiRelance">
          <header class="header-card">
            <p>{{ $t('piecesJointes.attachments')}}</p>
          </header>
          <div class="card-content">
            <app-pieces-jointes :checkPermissions="true"/>
          </div>
        </div>
      </div>
      <div class="column is-3" v-if="allRelances">
        <step-relance-enregistrement
          :allRelances="allRelances"
          :idCurrentRelance="currentRelance.id"
          @changeCurrentRelance="changeMouvementClient"
          @saveRelance="saveRelance"
          @deleteRelance="deleteRelance">
        </step-relance-enregistrement>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import messageSucces from '@/services/general/messageSucces';
import AppHeaderRelance from '@/components/relances/headerRelance';
import stepRelanceEnregistrement from '@/components/relances/stepRelanceEnregistrement';
import { create, getTexte } from '@/api/relances/index';
import PiecesJointes from '@/components/general/piecesJointes';
import validation from '@/services/relances/validation';
import translate from '@/services/relances/champsRelanceTranslator';
import preparationEnvoiBack from '@/services/relances/preparationEnvoieBack';
import validationGeneral from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { generationRelances } from '@/services/relances/relanceManager';
import formatIsoDate from '@/services/general/formatIsoDate';
import { GET_LAST_PAY_LOAD } from '@/configuration/relances/relancesConf';

const Attachments = createNamespacedHelpers('attachments');

export default {
  data() {
    return {
      allRelances: null,
      currentRelance: null,
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      constantes: {
        GET_LAST_PAY_LOAD,
      },
    };
  },
  props: {
    echeancesPaiement: Array,
    isRegrouperParPayeur: Boolean,
    isFromClient: Boolean,
  },
  components: {
    AppBreadcrumb,
    stepRelanceEnregistrement,
    AppHeaderRelance,
    appPiecesJointes: PiecesJointes,
    errorMsgComponent,
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      showAddAttachmentModal: 'showAddModal',
      insertAttachments: 'insert',
      setAttachmentElementId: 'setElementId',
      resetPiecesJointes: 'resetPiecesJointes',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async saveAllRelances() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const promiseResponseCreateRelance = [];
        this.allRelances.forEach((relance) => {
          const newRelance = preparationEnvoiBack(relance, true);
          promiseResponseCreateRelance.push(create(newRelance));
        });
        await Promise.all(promiseResponseCreateRelance);
        if (this.allRelances.length > 1) {
          messageSucces(this.allRelances.length + this.$t('addNewRelance.addSuccessMulti'));
        } else {
          messageSucces(this.$t('addNewRelance.addSuccess'));
        }
        this.$router.push({ name: 'l.bodac.relance-listeRelancesSave' });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.messages = [];
          this.messagesChampsVide = [];
          this.champsVide = [];
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async saveRelance(idRelance) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const relance = this.allRelances.find((el) => {
          return el.id === idRelance;
        });
        const index = this.allRelances.indexOf(this.allRelances.find((el) => {
          return el.id === idRelance;
        }));
        const newRelance = preparationEnvoiBack(relance, true);
        const response = await create(newRelance);
        await this.setAttachmentElementId({ id: response.data.result.id });
        await this.insertAttachments(response.data.result.id);
        messageSucces(this.$t('addNewRelance.addSuccess'));
        if (this.allRelances.length === 1) {
          this.$router.push({ name: 'c.bodac.relance', params: { relanceId: response.data.result.id } });
          loadingComponent.close();
          return;
        }
        this.allRelances.splice(index, 1);
        this.resetPiecesJointes();
        this.currentRelance = this.allRelances[0];
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.messages = [];
          this.messagesChampsVide = [];
          this.champsVide = [];
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    changeMouvementClient(idRelance) {
      this.currentRelance = this.allRelances.find((el) => {
        return el.id === idRelance;
      });
    },
    async updateTexteRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          mouvementClientIds: this.currentRelance.mouvementsClients.map(el => el.mouvementClientId),
          referenceTexte: this.currentRelance.numRelance > 3 ? 3 : this.currentRelance.numRelance,
          dateRelance: formatIsoDate(this.currentRelance.dateRelance),
        };
        this.currentRelance.texte = (await getTexte(params)).data.result;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    deleteRelance(idRelance) {
      const index = this.allRelances.indexOf(this.allRelances.find((el) => {
        return el.id === idRelance;
      }));
      this.allRelances.splice(index, 1);
      this.currentRelance = this.allRelances[0];
    },
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeFactures.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('addNewRelance.listeRetardPaiement'), route: { name: 'l.bodac.relance-listeDesRetards' }, isActive: false },
        { title: this.$i18n.t('addNewRelance.relance'), route: '', isActive: true },
      ];
    },
    isMultiRelance() {
      return this.allRelances && this.allRelances.length > 1;
    },
  },
  async mounted() {
    if (this.echeancesPaiement === undefined) {
      this.$router.push({ name: 'l.bodac.relance-listeDesRetards' });
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageGescom.retard.creationRelanceGroupe'));
      this.allRelances = await generationRelances(this.echeancesPaiement,
        this.isRegrouperParPayeur);
      this.resetPiecesJointes();
      this.currentRelance = this.allRelances[0];
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
